// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  GetAllInstrumentConfigurationsResponse,
  InstrumentConfiguration,
} from '@digitalasset/utility-operator-api-ts-client';
import { useQuery } from '@tanstack/react-query';
import { useUtilityOperatorApiClient } from '../../contexts/UtilityOperatorApiContext';

export type InstrumentsById = Record<string, InstrumentConfiguration>;

export const useGetAllInstrumentConfigurations = () => {
  const u = useUtilityOperatorApiClient();
  return useQuery({
    queryKey: ['getInstrumentConfigurations'],
    queryFn: () => u.getAllInstrumentConfigurations(),
  });
};

const instrumentsByInstrumentId = (data?: GetAllInstrumentConfigurationsResponse) => {
  const res = {} as InstrumentsById;
  data?.instrumentConfigurations.forEach((config) => {
    res[config.payload.defaultIdentifier.id] = config;
  });
  return res;
};

export const useInstrumentConfigurationsById = () => {
  const instrumentConfigurationQuery = useGetAllInstrumentConfigurations();

  return instrumentsByInstrumentId(instrumentConfigurationQuery.data);
};
